/**
 * Created by Angelika on 30.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as def from '../constants/defines';
import StalkerApiManager from '../api/StalkerApiLoaderManager';
import {onError} from './index';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();
let timer = null;

export function getUserData() {
    return dispatch => {
        dispatch({type: actionTypes.GET_USER_DATA_REQUEST});
        return loader.getUserData().then(
            data => dispatch({type: actionTypes.GET_USER_DATA_SUCCESS, data: data}),
            error => dispatch(onError(error, actionTypes.GET_USER_DATA_FAILED))
        )
    }
}

export function saveUserConfig() {
    return (dispatch, getState) => {
        const {users: {userData: {data: {id: userID}}}, channels: {activeChannel}, channelCards: {items: cardsItems}} = getState();
        dispatch({
            type: actionTypes.SAVE_USER_CONFIG,
            userID: userID,
            activeChannel: activeChannel,
            channelCards: cardsItems
        });
    }
}

export function loadUserConfig() {
    return (dispatch, getState) => {
        const {users: {userData: {data: {id: userID}}}, channels: {items: channels}} = getState();
        dispatch({
            type: actionTypes.LOAD_USER_CONFIG,
            userID: userID,
            channels: channels
        });
    }
}

export function clearUserData() {
    return {type: actionTypes.USER_DATA_CLEAR}
}

export function startSendUserActivity() {
    return dispatch => {
        dispatch({type: actionTypes.START_SEND_USER_ACTIVITY});
        dispatch(_updateUserActivity());
    }
}

function _updateUserActivity() {
    return (dispatch, getState) => {
        const {appContent: {activeFrame}, channels: {activeChannel}} = getState();
        dispatch({type: actionTypes.UPDATE_USER_ACTIVITY_REQUEST});
        loader._sendActivityRequest("/ping", "GET").then(
            data => {
                dispatch({type: actionTypes.UPDATE_USER_ACTIVITY_SUCCESS});
                timer = setTimeout(() => dispatch(_updateUserActivity()), def.UPDATE_ACTIVITY_TIMER);
            },
            error => {
                dispatch({type: actionTypes.UPDATE_USER_ACTIVITY_FAILED});
                clearInterval(timer);
                if (activeFrame === def.PLAYER_FRAME) {
                    dispatch(onError(error, actionTypes.UPDATE_USER_ACTIVITY_FAILED));
                } else {
                    if (activeChannel !== null) {
                        dispatch({type: actionTypes.RESET_CHANNEL_ACTIVE});
                    }
                }
            }
        )
    }
}

export function stopSendUserActivity() {
    clearInterval(timer);
    return({type: actionTypes.STOP_SEND_USER_ACTIVITY});
}


// WEBPACK FOOTER //
// ./src/actions/userData.js